/**
 * Progress Bars Animation
 * Animates progress bars when they enter the viewport
 */

class ProgressBarsAnimation {
  constructor() {
    this.elements = document.querySelectorAll('[data-progress-bars]');
    this.observers = new Map();
    this.init();
  }

  init() {
    if (this.elements.length === 0) return;

    // Use Intersection Observer for viewport detection
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3, // Trigger when 30% visible
    };

    this.elements.forEach((element) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !element.classList.contains('animated')) {
            this.animateProgressBars(element);
            observer.unobserve(element); // Only animate once
          }
        });
      }, observerOptions);

      observer.observe(element);
      this.observers.set(element, observer);
    });
  }

  animateProgressBars(container) {
    // Add animated class to trigger CSS transition
    container.classList.add('animated');
  }

  destroy() {
    // Clean up observers
    this.observers.forEach((observer) => {
      observer.disconnect();
    });
    this.observers.clear();
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProgressBarsAnimation();
  });
} else {
  new ProgressBarsAnimation();
}

// Re-initialize when Shopify section is re-rendered
document.addEventListener('shopify:section:load', () => {
  new ProgressBarsAnimation();
});

